import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomePage/index.vue'
import UserAgreement from '../views/UserAgreement/index.vue'
import PrivacyPage from '../views/Privacy/index.vue'
import PayAgreement from '../views/PayAgreement/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: UserAgreement
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPage
  },
  {
    path: '/payAgreement',
    name: 'payAgreement',
    component: PayAgreement
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
